import { render, staticRenderFns } from "./bottom.vue?vue&type=template&id=d485096a&"
var script = {}
import style0 from "./bottom.vue?vue&type=style&index=0&id=d485096a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports